import React, { ReactNode } from "react";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import Notification from "../notification/notification";
import { ValidatedValue } from "../../../helpers/validator";
import { observer } from "mobx-react";
import Formatter, { CapitalizationType } from "../../../helpers/formatter";

interface TextInputProps {
  capitalize?: CapitalizationType;
  value?: number | string | null;
  onChange?: (event: any) => void;
  validatedValue?: ValidatedValue<string | null>;
  validationDisabled?: boolean;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  formatted?: boolean;
  topLabel?: string;
  maxLength?: number;
  id?: string;
  multiline?: boolean;
  rows?: number;
  onlyNumberValue?: boolean;
  getHelperText?: () => ReactNode;
}

@observer
export default class TextInput extends React.Component<TextInputProps> {

  public render() {
    return (
      <TextField
        id={this.props.id}
        multiline={this.props.multiline}
        rows={this.props.rows}
        variant="outlined"
        required={this.props.required}
        size="small"
        className={classNames("text-input", this.props.className, { "disabled": this.props.disabled })}
        disabled={this.props.disabled}
        value={this.getValue()}
        error={this.displayError()}
        helperText={this.getHelperText()}
        onChange={(event) => {
          this.onChange(event);
        }}
        onKeyDown={() => {
          if (this.props.validatedValue) {
            this.props.validatedValue.clearValidation();
          }
        }}
        onBlur={(event) => {
          if (this.props.onChange) {
            this.props.onChange(event.target.value?.trim());
          }
          if (this.props.validatedValue) {
            if (this.props.validatedValue.value) {
              this.props.validatedValue.setValue(this.props.validatedValue.value.trim());
            }
          }
          this.validate();
        }}
        label={this.props.topLabel}
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{
          maxLength: this.props.maxLength
        }}
      />
    );
  }

  private onChange(event: any) {
    if (this.props.onlyNumberValue) {
      event.target.value = event.target.value.toString().replace(/[^0-9]/g, "");
    }

    const capitalizationType = (this.props.capitalize) ? this.props.capitalize : CapitalizationType.full;
    const text = Formatter.capitalizeWords(event.target.value, capitalizationType);
    if (this.props.onChange) {
      this.props.onChange(text);
    }
    if (this.props.validatedValue) {
      this.props.validatedValue.setValue(text);
    }
  }

  public validate() {
    if (this.props.validatedValue) {
      this.props.validatedValue.validate();
    }
  }

  private displayError(): boolean {
    return !this.props.validationDisabled && !!this.props.validatedValue?.errorMessage;
  }

  private getHelperText() {
    if (this.props.getHelperText) {
      return this.props.getHelperText();
    }
    return (this.displayError() ?
      <Notification type="error" message={this.props.validatedValue!.errorMessage!} /> : "");
  }

  private getValue() {
    return this.props.validatedValue
      ? this.props.validatedValue.value
      : this.props.value;
  }
}
